<template>
<div class="orgUnit">
  <p>
    <span>{{ getTitle }}：</span>
    {{ getDetail }}
  </p>
</div>
</template>

<script>
export default {
  name: "orgUnit",
  props: {
    info: {
      type: String,
      default: ''
    },
  },
  computed:{
    getTitle(){
      return this.info.split(':')[0]
    },
    getDetail(){
      return this.info.split(':')[1]
    }
  }
}
</script>

<style scoped>
.orgUnit {
  position: relative;
  width: 100%;
  text-align: left;
  font-size: 40px;
  /*background-color: #ead287;*/
}

.orgUnit p {
  margin: 30px 0;
}

.orgUnit p span {
  font-weight: bolder
}
</style>